import { AfterViewInit, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'pme-dialog-alert',
    templateUrl: './dialog-alert.component.html',
    styleUrls: ['./dialog-alert.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DialogAlertComponent implements OnInit, AfterViewInit {

  heroData: any = {};
  buttonData: any = {};
  size: string;
  disableCloseButton: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<DialogAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.heroData = {
      title: data.title,
      contents: data.contents,
      type: data.type
    };


    if (data.disableCloseButton) {
      this.disableCloseButton = data.disableCloseButton;
    }

    this.buttonData = data.buttons;
    this.size = data.size;
  }

  ngOnInit(): void {
  }



  handleClick(event) {
    switch (event) {
      case 'PRIMARY':
        if (this.buttonData && this.buttonData.primary) {
          if (this.buttonData.primary.action === 'close') {
            this.dialogRef.close();
          } else if (this.buttonData.primary.action === 'redirect') {
            document.location.href = this.buttonData.primary.callToAction;
          } else if (this.buttonData.primary.action === 'doCheckout') {
            this.dialogRef.close({
              doCheckout: true
            });
          } else if (this.buttonData.primary.action === 'changeToBankBillet') {
            this.dialogRef.close({
              changeToBankBillet: true
            });
          } else if (this.buttonData.primary.action === 'doCheckoutInThisPlan') {
            this.dialogRef.close({
              doCheckoutInThisPlan: true
            });
          } else if (this.buttonData.primary.action === 'applyModalCoupon') {
            this.dialogRef.close({
              applyModalCoupon: true
            })
          } else if (this.buttonData.primary.action === 'autoRechargeChange') {
            this.dialogRef.close({
              autoRechargeChange: true
            })
          } else if (this.buttonData.primary.action === 'redirectHome') {
            this.dialogRef.close({
              redirectHome: true
            })
          } else if (this.buttonData.primary.action === 'doDeleteCreditCard') {
            this.dialogRef.close({
              doDeleteCreditCard: true
            })
          }
        }
        break;

      case 'SECONDARY':
        if (this.buttonData && this.buttonData.secondary) {
          if (this.buttonData.secondary.action === 'close') {
            this.dialogRef.close();
          } else if (this.buttonData.secondary.action === 'redirect') {
            document.location.href = this.buttonData.secondary.callToAction;
          } else if (this.buttonData.secondary.action === 'disableCreditCard') {
            this.dialogRef.close({
              disableCreditCard: true
            });
          }
        }
        break;
      default:
        this.dialogRef.close();
        break;
    }
  }

  handleSize(size: any) {
    if (!size) return;

    const modal = document.getElementsByClassName("mat-mdc-dialog-container")[0] as HTMLElement;
    modal.style.maxWidth = sizes[size] ?? size;
  }

  ngAfterViewInit(): void {
    this.handleSize(this.size);
  }
}

const sizes = {
  SMALL: "300px",
  MEDIUM: "500px",
  LARGE: "800px",
  XLARGE: "1140px",
  CUSTOM_INVALID_PRODUCT: "580px",
}
